import {AxiosResponse} from "axios";
import React from "react";
import {RouteComponentProps, withRouter} from "react-router";
import {HttpError} from "../../../common/components/shared/httpError/httpError";
import Loader from "../../../common/components/shared/loader/loader";
import {HttpErrorModel} from "../../../common/models/httpError";
import {RouteParamsModel} from "../../../common/models/routeParams";
import {Api} from "../../../helpers/api";
import {DateUtils} from "../../../helpers/dateUtils";
import i18n from "../../../i18n/i18n";
import {TransportationService} from "../../services/transportationService";
import TransportationActions from "../transportationActions/transportationActions";
import SimpleNotification from "./simpleNotification/simpleNotification";
import ReloadButton from "../../../common/components/shared/reloadButton/reloadButton";
import {AlertModel} from "../../../alerts/models/alert";
import {InputLabel} from "@mui/material";
import {IOrderStore} from "../../stores/orderStore";
import {storesContext} from "../../../common/stores/stores";

interface TransportationNotificationsProps extends RouteComponentProps {
    element: "ticket" | "order";
}

interface TransportationNotificationsState {
    orderId: string;
    notifications: AlertModel[] | null | undefined;
    response: AxiosResponse<HttpErrorModel[] | any> | undefined;
}

class TransportationNotifications extends React.Component <TransportationNotificationsProps, TransportationNotificationsState> {
    static contextType = storesContext;

    constructor(props: any) {
        super(props);

        this.state = {
            notifications: undefined,
            response: undefined,
            orderId: ""
        };
    }

    private get notifications() {
        return this.state.notifications;
    }

    async componentDidMount() {
        const params = this.props.match.params as RouteParamsModel;

        this.getAllNotifications(params.id);
    }

    public render(): JSX.Element {
        const orderStore = this.context.orderStore as IOrderStore;

        return (
            <div className={`content transportation-${this.props.element}-content`}>
                <TransportationActions
                    orderId={this.state.orderId || ""}
                    element={this.props.element}
                    relationType={orderStore.relationType.value}
                />
                {this.renderContent()}
            </div>
        );
    }

    private renderContent() {
        if (!Api.isSuccess(this.state.response)) {
            return <HttpError
                response={this.state.response}
                cause={i18n.t("transportation.retrievalErrorSuffixForNotification")}
            />;
        } else if (this.notifications) {
            return this.renderSubContent();
        } else {
            return (
                <Loader/>
            );
        }
    }

    private renderSubContent() {
        return (
            <div className={`transportation-${this.props.element}-notification-sub-content`}>
                <div className="header" data-testid="header">
                    {i18n.t(`transportation.${this.props.element}.preview.header`, {number: this.state.orderId})}
                    <ReloadButton
                        reloadFunc={this.reload.bind(this)}
                        testId={`${this.props.element}-notification-reload-btn`}
                    />
                </div>
                <div className="sub-header" data-testid="sub-header">
                    {i18n.t("transportation.notificationTile")}
                </div>
                {this.renderNotificationsOrEmptyMessages()}
            </div>);
    }

    private renderNotificationsOrEmptyMessages() {
        if (this.notifications && this.notifications.length && this.notifications.length > 0) {
            return this.renderNotifications();
        } else if (this.notifications && this.notifications.length === 0) {
            return this.renderEmptyNotificationMessage();
        }
    }

    private renderNotifications() {

        return (
            <div>
                {this.notifications!.map((notification, index) => {
                    return (
                        <SimpleNotification
                            key={`notification-${index}`}
                            prefixClassName={`transportation-${this.props.element}`}
                            notificationType={notification.type}
                            message={notification.description}
                            date={this.formattedDate(notification.tags.date)}
                            testId={`notification-${index}`}
                        />
                    );
                })}
            </div>);
    }

    private renderEmptyNotificationMessage() {
        return (
            <div>
                <InputLabel data-testid="empty-notification-message">
                    {i18n.t("transportation.emptyNotificationMessage", {orderType: i18n.t(`transportation.orderType.${this.props.element}`)})}
                </InputLabel>
            </div>
        );
    }

    private formattedDate(date: any) {
        const dateTmp = DateUtils.getFormattedTimeWithDate(date).split("-");

        return <span className="date"><span className="bold">{dateTmp[0]}</span>{dateTmp[1]}</span>;
    }

    private async getAllNotifications(id: string) {
        const response = await TransportationService.getNotifications(id);

        this.setState({
            notifications: Api.isSuccess(response) ? response?.data?.data : null,
            response,
            orderId: id
        });
    }

    private async reload() {
        this.setState({notifications: undefined});

        this.getAllNotifications(this.state.orderId);
    }
}

export default withRouter(TransportationNotifications);